import DashboardMainComp from '@/components/features/superadmin/dashboard/DashboardMainComp';

const DashboardPage = () => {
  return (
    <>
      <DashboardMainComp />
    </>
  );
};

export default DashboardPage;
